import React from "react";
import perksImgSrc from "@irati/ui/images/perks2.png";
import { H4 } from "@irati/ui/src/Headings";
import { FormattedMessage } from "@irati/utils/lang";
import { PerksImage, Card } from "./styled";
var UserOnboardingSideBar = function () { return (React.createElement(Card, null,
    React.createElement(H4, { className: "text-center" },
        React.createElement(FormattedMessage, { id: "onboarding.sideBar.header" })),
    React.createElement(PerksImage, { src: perksImgSrc }))); };
export default UserOnboardingSideBar;
